<template>
  <v-layout justify-center align-center class="loading-mask" v-if="visible">
    <v-progress-circular indeterminate color="primary"></v-progress-circular>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      visible: false
    };
  }
};
</script>

<style lang="scss" scoped>
.loading-mask {
  background-color: rgba(255, 255, 255, 0.9);
  transition: opacity 0.3s;
  position: absolute;
  z-index: 1001;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0;
}
</style>
